export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - ABACAXI.e4e9c95a.pdf";